<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-12 module-title">REQUEST ACCESS</div>
      <div class="col-lg-12" v-if="!clientRequest">
        <div class="product-info">
          <form method="post" v-on:submit.prevent="requestClientAccess()">
            <div class="form-group">
              <label for="clientHostname">Hostname</label>
              <input type="text" id="clientHostname" v-model="clientHostname" class="form-control" />
            </div>
            <div class="form-group">
              <input type="submit" class="btn btn-send form-control" value="Verzenden" v-on:click.prevent="requestClientAccess()">
            </div>
          </form>
        </div>
      </div>

      <div class="col-lg-12 menu-item" v-if="clientRequest && !clientRequest.certificate.signed && !clientRequestExpired">
        <div class="product-info">
          <p>Vraag een beheerder om de aanvraag te ondertekenen. De certificaten kunnen hier gedownload worden nadat de aanvraag is ondertekent.</p>
        </div>
      </div>

      <div class="col-lg-12 menu-item" v-if="clientRequest && !clientRequest.certificate.signed && clientRequestExpired">
        <div class="product-info">
          <p>De aanvraag is verlopen.</p>

          <div class="form-group">
            <input type="submit" class="btn btn-send form-control" value="Verzenden" v-on:click.prevent="resetClientRequest()">
          </div>
        </div>
      </div>

      <div class="col-lg-12 menu-item" v-if="clientRequest && clientRequest.certificate.signed">
        <div class="product-info">
          <p>Download en installeer beide certificaten in de browser of in het besturingssysteem. Herstart na het installeren de browser.</p>
        </div>
        <div class="btn btn-pick btn-full-width" v-on:click="downloadCertificateChain()">
          <div class="btn-first-line">download</div>
          <div class="btn-primary-line">CERTIFICATE CHAIN</div>
        </div>
        <div class="btn btn-item-info btn-full-width" v-on:click="downloadPkcs12certificate()">
          <div class="btn-first-line">download</div>
          <div class="btn-primary-line">PKCS 12 CERTIFICATE</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    created () {
    },
    beforeDestroy () {
    },
    data () {
      return {
        clientRequest: null,
        clientHostname: '',
        requestError: '',
        clientRequestExpired: null
      }
    },
    computed: {
    },
    methods: {
      requestClientAccess () {
        this.$http.post(process.env.API_URL + '/scanner-client-request', {clientName: this.clientHostname}, {withCredentials: true}).then(response => {
          this.clientRequest = response.body
          this.clientRequestExpired = false

          if (!this.clientRequest.certificate.signed) {
            setTimeout(() => { this.refreshClientRequestStatus() }, 10000)
          }
        }, response => {
          this.requestError = response.errors.join(',')
        })
      },
      refreshClientRequestStatus () {
        this.$http.get(process.env.API_URL + '/scanner-client-request/' + this.clientRequest.requestSecret, {withCredentials: true}).then(response => {
          this.clientRequest = response.body

          if (!this.clientRequest.certificate.signed) {
            setTimeout(() => { this.refreshClientRequestStatus() }, 10000)
          }
        }, () => {
          this.clientRequestExpired = true
        })
      },
      downloadCertificateChain () {
        window.open(process.env.API_URL + '/' + this.clientRequest.certificate.certificateChain, 'download_window')
        window.focus()
      },
      downloadPkcs12certificate () {
        window.open(process.env.API_URL + '/' + this.clientRequest.certificate.pkcs12, 'download_window')
        window.focus()
      },
      resetClientRequest () {
        this.clientRequest = null
        this.clientHostname = ''
        this.requestError = null
        this.clientRequestExpired = null
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  a:hover {
    cursor: pointer;
  }

  .module-title {
    background-color: #ff8535;
    color: #fff;
    font-size: 20px;
    line-height: 40px;
  }

  a:hover {
    cursor: pointer;
  }

  .product-info {
    background-color: #fff;
    margin-top: 15px;
    padding: 10px;
    width: 100%;
  }

  .product-info table {
    width: 100%;
  }

  .product-info table td,
  .product-info table th {
    vertical-align: top;
  }

  .main-menu {
    padding-top: 15px;
  }

  .btn-full-width {
    width: 100%;
    margin-top: 15px;
  }

  .btn {
    cursor: pointer;
    border-radius: 0;
  }

  .menu-item {
    margin-bottom: 15px;
  }

  .btn-first-line {
    font-size: 10px;
    line-height: 10px;
    vertical-align: top;
  }

  .btn-primary-line {
    font-size: 20px;
    line-height: 26px;
    vertical-align: top;
  }

  .btn-send {
    background-color: #ff8535;
    color: #fff;
  }

  .btn-pick {
    background-color: #28a745;
    color: #fff;
  }

  .btn-item-info {
    background-color: #17a2b8;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/ClientAuthentication.vue